import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
export const IndividualAdvisorsAndMentorsProfile = ({advisorsMentorsDetails, loading}: any) => {
  const {formatMessage} = useIntl()
  const navigate = useNavigate()
  return (
    <>
      <div className='bg-white rounded-2 px-md-4 px-2 py-4 position-relative mb-4'>
        <div className='d-md-flex justify-content-between w-100 align-items-center mb-4'>
          <h2 className='font-size-16'>{formatMessage({id: 'Profile details'})}</h2>
          <button
            className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100 w-md-auto'
            onClick={() => {
              navigate(
                `/stakeholders/add-advisors-and-mentors?tab=${advisorsMentorsDetails?.type}&advisorMentorId=${advisorsMentorsDetails?.advisorMentorId}&edit=true`
              )
            }}
          >
            {formatMessage({id: 'Edit Profile'})}
          </button>
        </div>

        <div className='row gx-8 justify-content-between'>
          <div className='col-md-6'>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Gender'})}
              </p>
              {loading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>
                  {advisorsMentorsDetails?.individual?.gender || '-'}
                </p>
              )}
            </div>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Govt. Issued ID Type'})}
              </p>
              {loading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>
                  {advisorsMentorsDetails?.individual?.govtIssuedIdType?.name || '-'}
                </p>
              )}
            </div>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Govt. Issued ID Number'})}
              </p>
              {loading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-13 mb-0'>
                  {advisorsMentorsDetails?.individual?.govtIssuedIdNumber || '-'}
                </p>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='mb-4 d-flex gap-2 align-items-center'>
              <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                {formatMessage({id: 'Address'})}
              </p>
              {loading ? (
                <Skeleton
                  height={20}
                  width={190}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              ) : (
                <p className='font-size-14 mb-0'>
                  {!advisorsMentorsDetails?.individual?.address1 &&
                  !advisorsMentorsDetails?.individual?.address2 &&
                  !advisorsMentorsDetails?.individual?.city &&
                  !advisorsMentorsDetails?.individual?.state?.label &&
                  !advisorsMentorsDetails?.individual?.country?.label &&
                  !advisorsMentorsDetails?.individual?.zipCode
                    ? '-'
                    : `${
                        advisorsMentorsDetails?.institution?.address1
                          ? `${advisorsMentorsDetails?.institution?.address1},`
                          : ''
                      } ${
                        advisorsMentorsDetails?.institution?.address2
                          ? `${advisorsMentorsDetails?.institution?.address2},`
                          : ''
                      } ${
                        advisorsMentorsDetails?.institution?.city
                          ? `${advisorsMentorsDetails?.institution?.city},`
                          : ''
                      } ${
                        advisorsMentorsDetails?.institution?.state?.label
                          ? `${advisorsMentorsDetails?.institution?.state?.label},`
                          : ''
                      }${
                        advisorsMentorsDetails?.institution?.country?.label
                          ? `${advisorsMentorsDetails?.institution?.country?.label},`
                          : ''
                      } ${
                        advisorsMentorsDetails?.institution?.zipCode
                          ? `${advisorsMentorsDetails?.institution?.zipCode},`
                          : ''
                      }`}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
